module.exports = __webpack_public_path__ + "static/media/home12.0fb4ff3e.jpg";